const STOREID: string = process.env.NEXT_PUBLIC_STORE_ID || "";
const STORECODE: string = process.env.NEXT_PUBLIC_STORE_CODE || "";

const generateApiEndpoint = (storeId: string, jsonName: string) => {
  return `redisapi/readData.php?storeid=${storeId}&jsonname=${jsonName}`;
};

const generateECOMSAASEndpoint = (storeCode: string, jsonName: string) => {
  const formattedDate = new Date().getTime();
  return `${process.env.NEXT_PUBLIC_ECOMSAASASSETS}redisapi/${
    storeCode === "" ? "" : storeCode + "/"
  }${jsonName}.json?version=${formattedDate}`;
};

export const navLinks = [
  {
    name: "Phones",
    href: "/Phones",
  },
  {
    name: "Tablets",
    href: "/Tablets",
  },
  {
    name: "TVs",
    href: "/TVs",
  },
  {
    name: "All Products",
    href: "/All",
  },
];

// set 0 to remove fake discount
export const discount = 0.2;

export const AK = Object.freeze({
  ACCESSKEY: process.env.NEXT_PUBLIC_ACCESSKEY || "VilvaKart2023",
  STOREID: STOREID,
  STORECODE: STORECODE,
  FB_PIXEL_ID: process.env.NEXT_PUBLIC_FB_PIXEL_ID,
  eFEATUREDPRODUCTSJSONAPI: generateECOMSAASEndpoint(STORECODE, "catalog_products"),
  IPINFOURL: process.env.NEXT_PUBLIC_IPINFOURL,
  APIURL: process.env.NEXT_PUBLIC_APIURL,
  ECOMSAASAPIURL: process.env.NEXT_PUBLIC_ECOMSAASASSETS,
  REDDISAPIURL: process.env.NEXT_PUBLIC_PATHREDDISAPI,
  MOCKUPSURL: process.env.NEXT_PUBLIC_MOCKUPSURL,
  IMAGEURL: process.env.NEXT_PUBLIC_IMAGEURL,
  HDIMAGEURL: process.env.NEXT_PUBLIC_HDIMAGEURL,
  PRODUCTPAGEIMAGEURL: process.env.NEXT_PUBLIC_PRODUCTVIEWIMAGEURL,
  PRODUCTVIEWIMAGEURL: process.env.NEXT_PUBLIC_PRODUCTVIEWIMAGEURL,
  THUMBNAILSIMAGEURL: process.env.NEXT_PUBLIC_THUMBNAILSIMAGEURL,
  LOGINAPI: "api/login",
  REQUESTOTPAPI: "api/requestotp",
  VERIFYOTPAPI: "api/verifyotp",
  EMAILREQUESTOTPAPI: "api/email/requestotp",
  EMAILVERIFYOTPAPI: "api/email/verifyotp",
  INSTAMOJOAPI: "api/instamojo",
  HAODAPAYUPI: "api/haodapayupi",
  RAZORPAYAPI: "api/razorpay",
  PHONEPEAPI: "api/phonepe",
  STRIPEAPI: "api/stripe",
  CODPAYAPI: "api/codpayment",
  BANKTRANSFERAPI: "api/banktransfer",
  REGISTERAPI: "api/register",
  TWOFACTORLOGINAPI: "api/twofactor/login",
  LOGOUTAPI: "api/logout",
  PROFILEAPI: "api/userprofile",
  UPDATEPROFILEAPI: "api/userprofile/update",
  SUBMITCONTACTFORMAPI: "api/submit/contact-form",
  NEWSLETTERFORMAPI: "api/newsletter/subscribe",
  PRODUCTSAPI: "api/products",
  CATEGORYAPI: "api/category",
  SUBMITDELIVERYADDRESSAPI: "api/deliveryaddress",
  FETCHDELIVERYADDRESSAPI: "api/fetchdeliveryaddress",
  REMOVEDELIVERYADDRESSAPI: "api/removedeliveryaddress",
  CALCULATESHIPPINGCHARGEAPI: "api/calculate/shippingcharge",
  CALCULATECODCHARGEAPI: "api/calculate/codcharge",
  FBCONVERSIONPUSHAPI: `api/marketing/push-fbconversion?storeid=${STOREID}`,
  FCMPUSHAPI: "api/fcm-subscribers/store",
  COUPONSLISTAPI: "api/coupons",
  VALIDATECOUPONSLISTAPI: "api/validate-coupon",
  WISHLISTPUSHAPI: "api/userwishlist/push",
  WISHLISTFETCHAPI: "api/userwishlist/fetch",
  WISHLISTCLEARAPI: "api/userwishlist/clear",
  PRODUCTREVIEWSPUSHAPI: "api/add/product/review",
  PRODUCTREVIEWSFETCHAPI: "api/fetch/product/review",
  PRODUCTREVIEWSCLEARAPI: "api/userwishlist/clear",
  OVERALLPRODUCTSRATINGAPI: "api/products/average/rating",
  VIEWORDERAPI: "api/vieworder",
  VIEWORDERBYIDAPI: "api/vieworderbyid",
  VIEWORDERDETAILSAPI: "api/vieworderdetails",
  TRACKORDERAPI: "api/trackorder",
  DYNAMICPAGESAPI: "api/pages",
  DYNAMICBLOGSAPI: "api/blog",
  PRODUCTSJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=products`,
  CATEGORYJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=category`,
  SIZEJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=size`,
  WEIGHTJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=weight`,
  VARIATIONSJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=variations`,
  VERSIONMANAGERJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=versionmanager`,
  COLORCODESJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=colorcodes`,
  PRODUCTSCOLORCODESJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=productscolorcodes`,
  PRODUCTSSIZESJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=productssizes`,
  STORESJSONAPI: `redisapi/readData.php?storeid=${STOREID}&jsonname=stores`,
  COUNTRIESJSONAPI: `redisapi/readData.php?storeid=0&jsonname=countries`,
  ePRODUCTSJSONAPI: generateECOMSAASEndpoint(STORECODE, "products"),
  eCATEGORYJSONAPI: generateECOMSAASEndpoint(STORECODE, "category"),
  eSIZEJSONAPI: generateECOMSAASEndpoint("", "size"),
  eWEIGHTJSONAPI: generateECOMSAASEndpoint("", "weight"),
  eVARIATIONSJSONAPI: generateECOMSAASEndpoint("", "variations"),
  eVERSIONMANAGERJSONAPI: generateECOMSAASEndpoint(STORECODE, "versionmanager"),
  eCOLORCODESJSONAPI: generateECOMSAASEndpoint("", "colorcodes"),
  ePRODUCTSCOLORCODESJSONAPI: generateECOMSAASEndpoint(STORECODE, "productscolorcodes"),
  ePRODUCTSSIZESJSONAPI: generateECOMSAASEndpoint(STORECODE, "productssizes"),
  eSTORESJSONAPI: generateECOMSAASEndpoint(STORECODE, "stores"),
  eCOUNTRIESJSONAPI: generateECOMSAASEndpoint("", "countries"),
  eSTATESJSONAPI: generateECOMSAASEndpoint("", "states"),
  eORDERSTATUSJSONAPI: generateECOMSAASEndpoint("", "orderstatus"),
  MOCKUP_PRODUCTSJSONAPI: `products.json`,
  MOCKUP_CATEGORYJSONAPI: `category.json`,
  MOCKUP_SIZEJSONAPI: `size.json`,
  MOCKUP_WEIGHTJSONAPI: `weight.json`,
  MOCKUP_VARIATIONSJSONAPI: `variations.json`,
  MOCKUP_VERSIONMANAGERJSONAPI: `versionmanager.json`,
  MOCKUP_COLORCODESJSONAPI: `colorcodes.json`,
  MOCKUP_PRODUCTSCOLORCODESJSONAPI: `productscolorcodes.json`,
  MOCKUP_PRODUCTSSIZESJSONAPI: `productssizes.json`,
  MOCKUP_STORESJSONAPI: `stores.json`,
  MOCKUP_COUNTRIESJSONAPI: `countries.json`,
  MOCKUP_ORDERSTATUSJSONAPI: `orderstatus.json`,
  CATEGORY_HOMEPAGE_PRODUCTSAPI: "api/homepage/products",
  WALLETTRANSACTIONHISTORYAPI: "api/wallet/transaction/history",
  WALLETSUBMITAPI: "api/walletpayment",
  USERCARTINFOAPI: "api/usercartinfo/fetch",
  USERCARTINFOFETCHPUSHAPI: "api/usercartinfo/push",
  USERCARTINFOFETCHCLEARAPI: "api/usercartinfo/clear",
  SITEMAPXMLAPI: "product-feed/2",
});

export const SK = Object.freeze({
  CARTINFODATA: "cartinfoData",
  CATEGORYINFODATA: "categoryinfoData",
  COUPONINFODATA: "couponinfoData",
  PRODUCTSINFODATA: "productsinfoData",
  SIZEINFODATA: "sizeinfoData",
  COUNTRYINFODATA: "countryinfoData",
  WEIGHTINFODATA: "weightinfoData",
  VARIATIONSINFODATA: "variationsinfoData",
  PRODUCTSSIZEINFODATA: "productssizeinfoData",
  PRODUCTSCOLORCODESINFODATA: "productscolorcodeinfoData",
  COLORCODESINFODATA: "colorcodeinfoData",
  VERSIONMANAGERINFODATA: "versionmanagerinfoData",
  VERSIONINFODATA: "versioninfoData",
  STORESMANAGERINFODATA: "storesmanagerinfoData",
  DELIVERYCONTENTINFODATA: "deliverycontentinfoData",
  ORDERSTATUSINFODATA: "orderstatusinfoData",
  NEXTUSERINFODATA: "nextuserinfoData",
  NEXTCARTINFODATA: "nextcartinfoData",
});

export const APPENUMS = Object.freeze({
  COUPON_TYPES: {
    display: "display",
    hidden: "hidden",
  },
  COUPON_DISCOUNT_TYPES: {
    amount: "amount",
    percentage: "percentage",
    cashbackaamount: "cashbackamount",
    cashbackpercentage: "cashbackpercentage",
  },
  EVENT_ENUMS: {
    PAGE_VIEW: { id: 1, name: "PageView" },
    HOMEPAGE: { id: 2, name: "Homepage" },
    PRODUCT_LIST: { id: 3, name: "Product List" },
    PRODUCT_DETAILED: { id: 4, name: "Product Detailed" },
    ADD_TO_CART: { id: 5, name: "AddToCart" },
    CART: { id: 6, name: "Cart" },
    CHECKOUT: { id: 7, name: "Checkout" },
    INITIATE_CHECKOUT: { id: 8, name: "Initiate Checkout" },
    SIGN_IN: { id: 9, name: "Sign In" },
    SIGN_IN_WITH_EMAIL: { id: 10, name: "Sign In With Email" },
    SIGN_UP: { id: 11, name: "Sign Up" },
    ORDER_DETAILS: { id: 12, name: "Order Details" },
    ORDER_HISTORY: { id: 13, name: "Order History" },
    MY_PROFILE: { id: 14, name: "My Profile" },
    MY_ADDRESS: { id: 15, name: "My Address" },
    MY_WALLET: { id: 16, name: "My Wallet" },
    MY_WISHLIST: { id: 17, name: "My Wishlist" },
    PURCHASE: { id: 18, name: "Purchase" },
    TRACK_ORDER: { id: 19, name: "Track Order" },
    SHIPPING_AND_REFUND_POLICY: { id: 20, name: "Shipping And Refund Policy" },
    CHANGE_PASSWORD: { id: 21, name: "Change Password" },
    PROFILE_UPDATE: { id: 22, name: "Profile Update" },
    ORDER_SUCCESS: { id: 23, name: "OrderSuccess" },
    COMPLETE_REGISTRATION: { id: 24, name: "CompleteRegistration" },
  },
});